import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd"; //"react-beautiful-dnd";
import { ReactComponent as RequiredIcon } from "./required.svg";
import { XMarkIcon, EyeIcon } from "@heroicons/react/24/outline";
import NotRequiredIcon from "./notrequired";
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { Switch } from "@headlessui/react";
import { Auth } from "aws-amplify";
import {
  setCurrentSurvey,
  setNewQuestion,
  setSelectedSectionAndPage,
  updateTabStates,
  setQuestions,
} from "../../../store/actions";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  addQuestionFromAPI,
  getQuestionsFromAPI,
} from "../../../services/questionService";
import {
  updateSurveyFromAPI,
  getSurveyDetailFromAPI,
} from "../../../services/surveyService";
import SurveyPreview from "./surveyPreview";

export default function Design() {
  const themeMode = useSelector((state) => state.themeMode);
  // const currentSurvey = useSelector((state) => state.currentSurvey);
  // const selectedSectionAndPage = useSelector(
  //     (state) => state.selectedSectionAndPage
  // );
  // const newQuestion = useSelector((state) => state.newQuestion);
  const questions = useSelector((state) => state.questions);
  const organizations = useSelector((state) => state.organizations);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const currentSurvey = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurvey;
  const selectedSectionAndPage = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.selectedSectionAndPage;
  const newQuestion = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.newQuestion;
  // const questions = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.questions;
  // const organizations = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.organizations;
  const dispatch = useDispatch();

  let [token, setToken] = useState("");
  const [editingSurvey, setEditingSurvey] = useState(null);
  const [inputValue, setInputValue] = useState(""); // Metni tutmak için state
  const scrollRef = useRef(null);
  const questionTypesMenuRef = useRef(null);
  const textQuestionTypesMenuRef = useRef(null);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [deleteAllowMenuOpen, setDeleteAllowMenuOpen] = useState(false);
  const [deleteInfoMenuShow, setDeleteInfoMenuShow] = useState(false);
  const [questionAddInfoMenuShow, setQuestionAddInfoMenuShow] = useState(false);
  const [infoText, setInfoText] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedParam, setSelectedParam] = useState({
    param: "",
    pageIndex: null,
    qIndex: null,
    index: null,
    questionType: null,
  });
  const [sections, setSections] = useState([]);

  const textTypeOptions = [
    { value: "text", label: "Text" },
    { value: "email", label: "Email" },
    { value: "date", label: "Date" },
    { value: "number", label: "Number" },
    { value: "tel", label: "Tel" },
  ];

  const [selectedTextType, setSelectedTextType] = useState(textTypeOptions[0]); // Default option
  const [query, setQuery] = useState("");
  const [selectedValues, setSelectedValues] = useState({
    showNoneItem: false,
    showOtherItem: false,
    showAllItem: false,
  });

  const textQuestionTypes = [
    {
      value: "text",
    },
    {
      value: "email",
    },
    {
      value: "date",
    },
    {
      value: "number",
    },
    {
      value: "tel",
    },
  ];

  const questionTypes = [
    {
      value: 1,
      name: "Multiple Choice",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      ),
    },
    {
      value: 2,
      name: "Star Rating",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
          />
        </svg>
      ),
    },
    {
      value: 3,
      name: "Checkbox",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m4.5 12.75 6 6 9-13.5"
          />
        </svg>
      ),
    },
    {
      value: 4,
      name: "Dropdown",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m4.5 15.75 7.5-7.5 7.5 7.5"
          />
        </svg>
      ),
    },
    {
      value: 5,
      name: "Multi-Select Dropdown",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
          />
        </svg>
      ),
    },
    {
      value: 6,
      name: "Yes-No",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      ),
    },
    {
      value: 7,
      name: "Ranking",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"
          />
        </svg>
      ),
    },
    {
      value: 8,
      name: "Single Line",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
          />
        </svg>
      ),
    },
    {
      value: 9,
      name: "Long Text",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
          />
        </svg>
      ),
    },
  ];

  const [selectedQuestionType, setSelectedQuestionType] = useState(
    questionTypes[0]
  ); // Default option
  const [showQuestionTypes, setShowQuestionTypes] = useState(false);
  const [showTextQuestionTypes, setShowTextQuestionTypes] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);

  const filteredTextTypeOptions =
    query === ""
      ? textTypeOptions
      : textTypeOptions.filter((textType) => {
          return textType.label.toLowerCase().includes(query.toLowerCase());
        });

  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  async function getToken(token) {
    if (token) {
      setToken(token);
    } else {
      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    }
  }

  useEffect(() => {
    getToken();

    // Tıklama olayını dinle
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Component unmount olduğunda event listener'ı kaldır
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {}, [selectedTextType]); // This will trigger whenever selectedFileSize changes

  useEffect(() => {
    if (questions) {
      setFilteredQuestions(questions);
    }
  }, [questions]);

  const undoChanges = () => {
    setEditingSurvey(JSON.parse(JSON.stringify(currentSurvey)));
    arrangeSections();
  };

  const scrollToBottom = () => {
    // scrollRef.current?.scrollIntoView({ behavior: "smooth" });
    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight + 1000,
        behavior: "smooth", // Smooth scroll effect
      });
    }, 1);
  };

  // console.log(filteredOptions);
  const arrangeSections = () => {
    setSections([]);
    const _currentSurvey = JSON.parse(JSON.stringify(currentSurvey));
    _currentSurvey?.content?.pages
      ?.filter((x) => x.name !== "intro")
      .forEach((section, index) => {
        let _newSection = {
          name: section.title,
          pages: [],
        };
        section.elements[0].elements?.forEach((element, index) => {
          if (element.type === "html") {
            let _newPage = {
              name: element.name,
              questions: [],
            };
            _newSection.pages.push(_newPage);
          } else if (element.type === "panel") {
            let _newQuestion = {};
            if (
              element.elements[0].type === "radiogroup" ||
              element.elements[0].type === "dropdown"
            ) {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                weight: element.elements[0].weight
                  ? element.elements[0].weight
                  : 1.0,
                editing_weight: element.elements[0].weight
                  ? element.elements[0].weight
                  : 1.0,
                elements: JSON.parse(
                  JSON.stringify(element.elements[0].choices)
                ),
                editing_elements: JSON.parse(
                  JSON.stringify(element.elements[0].choices)
                ),
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "tagbox") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                elements: JSON.parse(
                  JSON.stringify(element.elements[0].choices)
                ),
                editing_elements: JSON.parse(
                  JSON.stringify(element.elements[0].choices)
                ),
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "rating") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                weight: element.elements[0].weight
                  ? element.elements[0].weight
                  : 1.0,
                editing_weight: element.elements[0].weight
                  ? element.elements[0].weight
                  : 1.0,
                rateCount: element.elements[0].rateCount,
                editing_rateCount: element.elements[0].rateCount,
                rateMax: element.elements[0].rateMax,
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                rateType: "stars",
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "boolean") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                renderAs: element.elements[0].renderAs,
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "checkbox") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                elements: JSON.parse(
                  JSON.stringify(element.elements[0].choices)
                ),
                editing_elements: JSON.parse(
                  JSON.stringify(element.elements[0].choices)
                ),
                colCount: element.elements[0].colCount,
                showOtherItem: element.elements[0].showOtherItem,
                editing_showOtherItem: element.elements[0].showOtherItem,
                showNoneItem: element.elements[0].showNoneItem,
                editing_showNoneItem: element.elements[0].showNoneItem,
                showSelectAllItem: element.elements[0].showSelectAllItem,
                editing_showSelectAllItem:
                  element.elements[0].showSelectAllItem,
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "ranking") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                elements: JSON.parse(
                  JSON.stringify(element.elements[0].choices)
                ),
                editing_elements: JSON.parse(
                  JSON.stringify(element.elements[0].choices)
                ),
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            // if (element.elements[0].type === "file") {
            //   _newQuestion = {
            //     name: element.elements[0].title,
            //     type: element.elements[0].type,
            //     elements: element.elements[0].choices,
            //     colCount: element.elements[0].colCount,
            //     allowMultiple: element.elements[0].allowMultiple,
            //     maxSize: element.elements[0].maxSize,
            //     isRequired: element.elements[0].isRequired
            //       ? element.elements[0].isRequired
            //       : false,
            //     isEditing: false,
            //   };
            // }
            if (element.elements[0].type === "comment") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                rows: element.elements[0].rows,
                allowResize: element.elements[0].allowResize,
                maxLength: element.elements[0].maxLength,
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "text") {
              if (element.elements[0].inputType) {
                let inputType = element.elements[0].inputType;
                if (inputType === "email") {
                  _newQuestion = {
                    name: element.elements[0].title,
                    editing_name: element.elements[0].title,
                    type: element.elements[0].type,
                    editing_type: element.elements[0].type,
                    maxLength: element.elements[0].maxLength,
                    isRequired: element.elements[0].isRequired
                      ? element.elements[0].isRequired
                      : false,
                    isEditing: false,
                    is_exist: false,
                    inputType: inputType,
                    editing_inputType: inputType,
                  };
                } else if (inputType === "tel") {
                  _newQuestion = {
                    name: element.elements[0].title,
                    editing_name: element.elements[0].title,
                    type: element.elements[0].type,
                    editing_type: element.elements[0].type,
                    maxLength: element.elements[0].maxLength,
                    isRequired: element.elements[0].isRequired
                      ? element.elements[0].isRequired
                      : false,
                    validators: element.elements[0].validators,
                    isEditing: false,
                    is_exist: false,
                    inputType: inputType,
                    editing_inputType: inputType,
                  };
                } else if (inputType === "date") {
                  _newQuestion = {
                    name: element.elements[0].title,
                    editing_name: element.elements[0].title,
                    type: element.elements[0].type,
                    editing_type: element.elements[0].type,
                    maxLength: element.elements[0].maxLength,
                    isRequired: element.elements[0].isRequired
                      ? element.elements[0].isRequired
                      : false,
                    validators: element.elements[0].validators,
                    isEditing: false,
                    is_exist: false,
                    inputType: inputType,
                    editing_inputType: inputType,
                  };
                } else if (inputType === "number") {
                  _newQuestion = {
                    name: element.elements[0].title,
                    editing_name: element.elements[0].title,
                    type: element.elements[0].type,
                    editing_type: element.elements[0].type,
                    min: element.elements[0].min,
                    max: element.elements[0].max,
                    isRequired: element.elements[0].isRequired
                      ? element.elements[0].isRequired
                      : false,
                    validators: element.elements[0].validators,
                    isEditing: false,
                    is_exist: false,
                    inputType: inputType,
                    editing_inputType: inputType,
                  };
                }
              } else {
                _newQuestion = {
                  name: element.elements[0].title,
                  editing_name: element.elements[0].title,
                  type: element.elements[0].type,
                  editing_type: element.elements[0].type,
                  maxLength: element.elements[0].maxLength,
                  isRequired: element.elements[0].isRequired
                    ? element.elements[0].isRequired
                    : false,
                  isEditing: false,
                  is_exist: false,
                  inputType: "text",
                  editing_inputType: "text",
                };
              }
            }
            _newSection.pages[_newSection.pages.length - 1].questions.push(
              _newQuestion
            );
          }
        });
        setSections((prev) => [...prev, _newSection]);
      });
  };

  useEffect(() => {
    if (currentSurvey) {
      const _currentSurvey = JSON.parse(JSON.stringify(currentSurvey));
      console.log("current surveyyyy", currentSurvey);
      if (isFirstRender || _currentSurvey.willUpdate) {
        _currentSurvey["willUpdate"] = false;
        arrangeSections();
        setIsFirstRender(false);
      }

      setEditingSurvey(_currentSurvey);
    }
  }, [currentSurvey]);

  useEffect(() => {
    if (selectedSectionAndPage.sectionName !== "") {
      arrangeSections();
    }
  }, [selectedSectionAndPage]);

  const fixQuestionTypeName = (type) => {
    switch (type) {
      case "radiogroup":
        return "Multiple Choice";
      case "dropdown":
        return "Dropdown";
      case "checkbox":
        return "Checkbox";
      case "text":
        return "Single Line";
      case "comment":
        return "Long Text";
      case "rating":
        return "Star Rating";
      case "boolean":
        return "Yes-No";
      case "tagbox":
        return "Multi-Select Dropdown";
      case "ranking":
        return "Ranking";
      case "Multiple Choice":
        return "radiogroup";
      case "Dropdown":
        return "dropdown";
      case "Checkbox":
        return "checkbox";
      case "Single Line":
        return "text";
      case "Long Text":
        return "comment";
      case "Star Rating":
        return "rating";
      case "Yes-No":
        return "boolean";
      case "Multi-Select Dropdown":
        return "tagbox";
      case "Ranking":
        return "ranking";
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    // const regex = /^\d+(\.\d{1,2})?$/; // Sayı formatı: X, X.X veya X.XX
    // if (regex.test(e.target.value) || e.target.value === "") {
    //     setValue(e.target.value);
    // }
  };

  const questionIsExist = (questionName) => {
    let isExist = false;
    let count = 0;
    for (const section of sections) {
      for (const page of section.pages) {
        for (const question of page.questions) {
          if (question.name === questionName) {
            isExist = true;
            ++count;
            if (count > 1) {
              break;
            }
          }
        }
      }
    }
    return isExist;
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;

    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    let qIndex = 0;
    let destIndex = destination.index;
    let sourcPageIndex = source.droppableId.split("-")[1];
    let destPageIndex = destination.droppableId.split("-")[1];

    if (selectedSectionAndPage.pageName === "All") {
      const htmlIndexes = _editingSurvey.content.pages
        .find(
          (s) =>
            s.name.toLowerCase() ===
            selectedSectionAndPage.sectionName.toLowerCase()
        )
        .elements[0].elements.map((item, index) =>
          item.type === "html" ? index : null
        )
        .filter((index) => index !== null);
      qIndex = htmlIndexes[sourcPageIndex] + source.index + 1;
      destIndex = htmlIndexes[destPageIndex] + destination.index + 1;
    } else {
      qIndex =
        _editingSurvey.content.pages
          .find(
            (s) =>
              s.name.toLowerCase() ===
              selectedSectionAndPage.sectionName.toLowerCase()
          )
          .elements[0].elements.findIndex(
            (e) =>
              e.type === "html" && e.name === selectedSectionAndPage.pageName
          ) +
        source.index +
        1;
      destIndex =
        _editingSurvey.content.pages
          .find(
            (s) =>
              s.name.toLowerCase() ===
              selectedSectionAndPage.sectionName.toLowerCase()
          )
          .elements[0].elements.findIndex(
            (e) =>
              e.type === "html" && e.name === selectedSectionAndPage.pageName
          ) +
        destIndex +
        1;
      sourcPageIndex = _sections[
        selectedSectionAndPage.sectionIndex
      ].pages.findIndex((p) => p.name === selectedSectionAndPage.pageName);
      destPageIndex = sourcPageIndex;
    }

    const [movedItem] = _editingSurvey.content.pages
      .find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      )
      .elements[0].elements.splice(qIndex, 1);
    _editingSurvey.content.pages
      .find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      )
      .elements[0].elements.splice(destIndex, 0, movedItem);
    setEditingSurvey(_editingSurvey);

    const [sectionMovedItem] = _sections[
      selectedSectionAndPage.sectionIndex
    ].pages[sourcPageIndex].questions.splice(source.index, 1);
    _sections[selectedSectionAndPage.sectionIndex].pages[
      destPageIndex
    ].questions.splice(destination.index, 0, sectionMovedItem);
    setSections(_sections);

    saveChanges(_editingSurvey);
  };

  const updateQuestionType = (pageIndex, questionIndex, type) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (type === "checkbox") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[
        surveyContentQIndex
      ].elements[0].showSelectAllItem = false;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[
        surveyContentQIndex
      ].elements[0].showNoneItem = false;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[
        surveyContentQIndex
      ].elements[0].showOtherItem = false;
    } else if (type === "rating") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].rateCount = 5;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].rateMax = 5;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].rateType =
        "stars";
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].displayMode =
        "buttons";
    }

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_type = type;
      if (type === "checkbox") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_showSelectAllItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_showNoneItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_showOtherItem = false;
      } else if (type === "rating") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_rateCount = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].rateMax = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].rateType = "stars";
      } else if (type === "text") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_inputType = "text";
      }
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_type = type;
      if (type === "checkbox") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_showSelectAllItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_showNoneItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_showOtherItem = false;
      } else if (type === "rating") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_rateCount = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].rateMax = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].rateType = "stars";
      } else if (type === "text") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_inputType = "text";
      }
    }

    setSections(_sections);
    setEditingSurvey(_editingSurvey);
  };

  const updateTextQuestionType = (pageIndex, questionIndex, type) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_inputType = type;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_inputType = type;
    }

    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0].editing_inputType =
      type;

    setSections(_sections);
    setEditingSurvey(_editingSurvey);
  };

  const updateQuestionIsRequired = (question, pageIndex, questionIndex) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    const _newIsReq = !question.isRequired;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].isRequired = _newIsReq;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].isRequired = _newIsReq;
    }

    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0].isRequired =
      _newIsReq;

    setSections(_sections);
    setEditingSurvey(_editingSurvey);

    if (!question.isEditing) {
      saveChanges(_editingSurvey);
    }
  };

  const updateQuestionIsEditing = (question, pageIndex, questionIndex) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    const _newIsEditing = !question.isEditing;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].isEditing = _newIsEditing;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].isEditing = _newIsEditing;
    }
    setSections(_sections);
  };

  async function undoQuestionChanges(question, pageIndex, questionIndex) {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    const _newIsEditing = !question.isEditing;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].isEditing = _newIsEditing;
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_name =
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].name;
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_type =
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].type;
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ]["editing_weight"] =
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].weight;
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions[sectionQIndex].editing_elements !== undefined
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_elements = JSON.parse(
          JSON.stringify(
            _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
              .questions[sectionQIndex].elements
          )
        );
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].newOption = "";
      }
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions[sectionQIndex].editing_rateCount !== undefined
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_rateCount =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].rateCount;
      }
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions[sectionQIndex].type === "checkbox"
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_showSelectAllItem =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].showSelectAllItem;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_showNoneItem =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].showNoneItem;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_showOtherItem =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].showOtherItem;
      } else if (
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions[sectionQIndex].type === "text"
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_inputType =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].inputType;
      }
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].isEditing = _newIsEditing;
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_name = _sections[
        selectedSectionAndPage.sectionIndex
      ].pages.find((p) => p.name === selectedSectionAndPage.pageName).questions[
        sectionQIndex
      ].name;
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_type = _sections[
        selectedSectionAndPage.sectionIndex
      ].pages.find((p) => p.name === selectedSectionAndPage.pageName).questions[
        sectionQIndex
      ].type;
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex]["editing_weight"] = _sections[
        selectedSectionAndPage.sectionIndex
      ].pages.find((p) => p.name === selectedSectionAndPage.pageName).questions[
        sectionQIndex
      ].weight;
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_elements !== undefined
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_elements = JSON.parse(
          JSON.stringify(
            _sections[selectedSectionAndPage.sectionIndex].pages.find(
              (p) => p.name === selectedSectionAndPage.pageName
            ).questions[sectionQIndex].elements
          )
        );
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].newOption = "";
      }
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_rateCount !== undefined
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_rateCount = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].rateCount;
      }
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].type === "checkbox"
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_showSelectAllItem = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].showSelectAllItem;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_showNoneItem = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].showNoneItem;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_showOtherItem = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].showOtherItem;
      } else if (
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].type === "text"
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_inputType = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].inputType;
      }
    }
    setSections(_sections);
    // arrangeSections();
  }

  const saveQuestionChanges = (question, pageIndex, questionIndex) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (question.isEditing) {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].title =
        question.editing_name;
      if (question.editing_elements !== undefined) {
        question.editing_elements.forEach((item) => {
          if (item.weight) {
            item.weight = parseFloat(item.weight);
          }
        });
        _editingSurvey.content.pages.find(
          (s) =>
            s.name.toLowerCase() ===
            selectedSectionAndPage.sectionName.toLowerCase()
        ).elements[0].elements[surveyContentQIndex].elements[0].choices =
          JSON.parse(JSON.stringify(question.editing_elements));
      }
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].type =
        question.editing_type;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0]["weight"] =
        parseFloat(question.editing_weight);
    }
    if (question.type === "checkbox") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[
        surveyContentQIndex
      ].elements[0].showSelectAllItem = question.editing_showSelectAllItem;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].showNoneItem =
        question.editing_showNoneItem;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].showOtherItem =
        question.editing_showOtherItem;
    } else if (question.type === "rating") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].rateCount =
        question.editing_rateCount;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].rateMax =
        question.editing_rateCount;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].rateType =
        question.rateType;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].displayMode =
        "buttons";
    } else if (question.type === "text") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].elements[0].inputType =
        question.editing_inputType;
    }
    setEditingSurvey(_editingSurvey);

    const _newIsEditing = !question.isEditing;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].isEditing = _newIsEditing;
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].name =
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_name;
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].type =
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].editing_type;
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ]["weight"] = parseFloat(
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions[sectionQIndex].editing_weight
      );
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions[sectionQIndex].elements !== undefined
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].elements = JSON.parse(
          JSON.stringify(
            _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
              .questions[sectionQIndex].editing_elements
          )
        );
      }
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions[sectionQIndex].editing_rateCount !== undefined
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].rateCount =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].editing_rateCount;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].rateMax =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].editing_rateCount;
      }
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions[sectionQIndex].editing_type === "checkbox"
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].showSelectAllItem =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].editing_showSelectAllItem;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].showNoneItem =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].editing_showNoneItem;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].showOtherItem =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].editing_showOtherItem;
      } else if (
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions[sectionQIndex].editing_type === "text"
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].inputType =
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].editing_inputType;
      }
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].isEditing = _newIsEditing;
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].name = _sections[
        selectedSectionAndPage.sectionIndex
      ].pages.find((p) => p.name === selectedSectionAndPage.pageName).questions[
        sectionQIndex
      ].editing_name;
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].type = _sections[
        selectedSectionAndPage.sectionIndex
      ].pages.find((p) => p.name === selectedSectionAndPage.pageName).questions[
        sectionQIndex
      ].editing_type;
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex]["weight"] = parseFloat(
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_weight
      );
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].elements !== undefined
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].elements = JSON.parse(
          JSON.stringify(
            _sections[selectedSectionAndPage.sectionIndex].pages.find(
              (p) => p.name === selectedSectionAndPage.pageName
            ).questions[sectionQIndex].editing_elements
          )
        );
      }
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_rateCount !== undefined
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].rateCount = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_rateCount;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].rateMax = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_rateCount;
      }
      if (
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_type === "checkbox"
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].showSelectAllItem = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_showSelectAllItem;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].showNoneItem = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_showNoneItem;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].showOtherItem = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_showOtherItem;
      } else if (
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_type === "text"
      ) {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].inputType = _sections[
          selectedSectionAndPage.sectionIndex
        ].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].editing_inputType;
      }
    }
    setSections(_sections);

    if (!_newIsEditing) {
      saveChanges(_editingSurvey);
    }
  };

  const handleWeightChange = (pageIndex, questionIndex, value) => {
    value = value.replace(",", ".");
    value = value.replace(/[^0-9.]/g, "");
    value = value.replace(/(\..*?)\./g, "$1");

    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ]["editing_weight"] = value;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex]["editing_weight"] = value;
    }

    setSections(_sections);
  };

  const handleQuestionNameChange = (pageIndex, questionIndex, value) => {
    let isExist = questionIsExist(value);

    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_name = value;
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].is_exist = isExist;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_name = value;
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].is_exist = isExist;
    }

    if (value.length > 0) {
      let _filteredQuestions = questions.filter((question) =>
        question.question.toLowerCase().includes(value.toLowerCase())
      );
      _filteredQuestions = [
        ...new Map(
          _filteredQuestions.map((item) => [
            `${item.question}-${item.type}`,
            item,
          ])
        ).values(),
      ];
      setFilteredQuestions(_filteredQuestions);
    } else {
      setFilteredQuestions(questions);
    }
  };

  const editQuestionFromQBank = (pageIndex, questionIndex, question) => {
    let isExist = questionIsExist(question.question);

    question["choices"] = question.options.map((option, index) => {
      return {
        value: index + 1,
        text: option,
      };
    });

    setSections((prev) => {
      const newSections = [...prev];
      const updatedQuestions = [
        ...newSections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions,
      ];
      // updatedQuestions[questionIndex].name = question.question;
      updatedQuestions[questionIndex].editing_name = question.question;
      // updatedQuestions[questionIndex].elements = question.choices;
      updatedQuestions[questionIndex].editing_elements = question.choices;
      // updatedQuestions[questionIndex].type = question.type;
      updatedQuestions[questionIndex].editing_type = question.type;
      updatedQuestions[questionIndex].is_exist = isExist;

      newSections[selectedSectionAndPage.sectionIndex].pages[
        pageIndex
      ].questions = updatedQuestions;
      return newSections;
    });

    setFilteredQuestions([]);
  };

  const handleOptionWeightChange = (
    pageIndex,
    questionIndex,
    choiceIndex,
    value
  ) => {
    value = value.replace(",", ".");
    value = value.replace(/[^0-9.]/g, "");
    value = value.replace(/(\..*?)\./g, "$1");

    if (parseFloat(value) > 5) {
      value = "5";
    }

    // if (regex.test(value)) {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_elements[choiceIndex].weight = value;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_elements[choiceIndex].weight = value;
    }

    setSections(_sections);
    // }
  };

  const handleChoiceTextChange = (
    pageIndex,
    questionIndex,
    choiceIndex,
    value,
    type
  ) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_elements[choiceIndex].text = value;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_elements[choiceIndex].text = value;
    }

    // if (type === "checkbox" || type === "ranking") {
    //     _editingSurvey.content.pages.find(s => s.name === selectedSectionAndPage.sectionName).elements[0].elements[surveyContentQIndex].elements[0].choices[choiceIndex] = value;
    // }
    // else {
    //     _editingSurvey.content.pages.find(s => s.name === selectedSectionAndPage.sectionName).elements[0].elements[surveyContentQIndex].elements[0].choices[choiceIndex].text = value;
    // }
    setSections(_sections);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value); // Kullanıcının yazdığı metni güncelle
  };

  const handleNewOptionChange = (pageIndex, questionIndex, newVal) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
      sectionQIndex
    ].newOption = newVal;

    setSections(_sections);
  };

  const handleAddOption = (pageIndex, questionIndex, type) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_elements.push({
        value:
          _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
            .questions[sectionQIndex].editing_elements.length + 1,
        text: _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions[sectionQIndex].newOption,
        // weight: (5 / 7) * (_sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].editing_elements.length + 1)
      });
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages
        .find((p) => p.name === selectedSectionAndPage.pageName)
        .questions[sectionQIndex].editing_elements.push({
          value:
            _sections[selectedSectionAndPage.sectionIndex].pages.find(
              (p) => p.name === selectedSectionAndPage.pageName
            ).questions[sectionQIndex].editing_elements.length + 1,
          text: _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
            .questions[sectionQIndex].newOption,
          // weight: 1.0
        });
    }

    _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
      sectionQIndex
    ].newOption = "";

    setSections(_sections);
    setInputValue("");
  };
  const increaseRate = (pageIndex, questionIndex) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_rateCount += 1;
      // _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].rateMax += 1;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_rateCount += 1;
      // _sections[selectedSectionAndPage.sectionIndex].pages.find(p => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex].rateMax += 1;
    }

    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0].rateCount += 1;
    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0].rateMax += 1;

    setSections(_sections);
    setEditingSurvey(_editingSurvey);
  };

  // Rate azaltma (minimum 1'e sabitleme)
  const decreaseRate = (pageIndex, questionIndex) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_rateCount -= 1;
      // _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].rateMax -= 1;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_rateCount -= 1;
      // _sections[selectedSectionAndPage.sectionIndex].pages.find(p => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex].rateMax -= 1;
    }

    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0].rateCount -= 1;
    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0].rateMax -= 1;

    setSections(_sections);
    setEditingSurvey(_editingSurvey);
  };

  const handleCheckBoxOptions = (pageIndex, questionIndex, value, param) => {
    let _sections = [...sections];
    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        questionIndex
      ]["editing_" + param] = value;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[questionIndex]["editing_" + param] = value;
    }

    setSections(_sections);
  };

  const handleDeleteQuestion = (pageIndex, questionIndex) => {
    setDeleteAllowMenuOpen(false);
    setDeleteInfoMenuShow(true);
    let _sections = [...sections];
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[
        pageIndex
      ].questions.splice(sectionQIndex, 1);
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages
        .find((p) => p.name === selectedSectionAndPage.pageName)
        .questions.splice(sectionQIndex, 1);
    }

    _editingSurvey.content.pages
      .find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      )
      .elements[0].elements.splice(surveyContentQIndex, 1);

    setSections(_sections);
    setEditingSurvey(_editingSurvey);

    saveChanges(_editingSurvey);
  };

  const handleDeleteOption = (pageIndex, questionIndex, optionIndex, type) => {
    setDeleteAllowMenuOpen(false);
    setDeleteInfoMenuShow(true);
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_elements.splice(optionIndex, 1);
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages
        .find((p) => p.name === selectedSectionAndPage.pageName)
        .questions[sectionQIndex].editing_elements.splice(optionIndex, 1);
    }

    setSections(_sections);
  };

  const changeBooleanType = (pageIndex, questionIndex, type) => {
    setSections((prev) => {
      const newSections = [...prev];
      const updatedQuestions = [
        ...newSections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions,
      ];
      const updatedRender = type;
      updatedQuestions[questionIndex].renderAs = updatedRender;
      newSections[selectedSectionAndPage.sectionIndex].pages[
        pageIndex
      ].questions = updatedQuestions;

      return newSections;
    });
  };

  const changeCommentTypeOptions = (
    pageIndex,
    questionIndex,
    option,
    param
  ) => {
    setSections((prev) => {
      const newSections = [...prev];
      const updatedQuestions = [
        ...newSections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
          .questions,
      ];
      if (param === "rows") {
        updatedQuestions[questionIndex].rows = option;
      } else if (param === "allowResize") {
        updatedQuestions[questionIndex].allowResize =
          option === "no" ? false : true;
      } else if (param === "maxLength") {
        updatedQuestions[questionIndex].maxLength = option;
      }
      newSections[selectedSectionAndPage.sectionIndex].pages[
        pageIndex
      ].questions = updatedQuestions;

      return newSections;
    });
  };

  const changeTextTypeOptions = (pageIndex, questionIndex, option, param) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let _sections = [...sections];
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    // setSections((prev) => {
    //     const newSections = [...prev];
    //     const updatedQuestions = [
    //         ...newSections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
    //             .questions,
    //     ];
    //     if (param === "inputType") {
    //         updatedQuestions[questionIndex].inputType = option.value;
    //     }
    //     if (option.value === "number") {
    //         updatedQuestions[questionIndex].min =
    //             updatedQuestions[questionIndex].min ?? 0;
    //         updatedQuestions[questionIndex].max =
    //             updatedQuestions[questionIndex].max ?? 10;
    //     } else {
    //         if ("min" in updatedQuestions[questionIndex]) {
    //             delete updatedQuestions[questionIndex].min;
    //         }
    //         if ("max" in updatedQuestions[questionIndex]) {
    //             delete updatedQuestions[questionIndex].max;
    //         }
    //     }
    //     newSections[selectedSectionAndPage.sectionIndex].pages[
    //         pageIndex
    //     ].questions = updatedQuestions;

    //     return newSections;
    // });

    if (selectedSectionAndPage.pageName === "All") {
      if (param === "min") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].min = option;
      } else if (param === "max") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].max = option;
      }
    } else {
      if (param === "min") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].min = option;
      } else if (param === "max") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].max = option;
      }
    }

    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0][param] = option;

    setSections(_sections);
    setEditingSurvey(_editingSurvey);
  };

  useEffect(() => {
    if (newQuestion.type !== undefined) {
      addNewQuestion(0, 0, newQuestion);
      // dispatch(setNewQuestion({}));
      dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {}));
    }
  }, [newQuestion]);

  function getNewQIndexes(
    currentSectionName,
    currentPageName,
    _editingSurvey,
    _sections,
    pageIndex,
    questionIndex
  ) {
    let sectionQIndex = 0;
    let surveyContentQIndex = 0;

    if (currentPageName === "All") {
      if (newQuestion.from === "qbank" || newQuestion.from === "inputpanel") {
        sectionQIndex = _sections.find((s) => s.name === currentSectionName)
          ?.pages[
          _sections.find((s) => s.name === currentSectionName)?.pages.length - 1
        ].questions.length;
        surveyContentQIndex = _editingSurvey.content?.pages.find(
          (s) => s.name === currentSectionName
        ).elements[0].elements.length;
      } else {
        sectionQIndex = questionIndex;
        const htmlIndexes = _editingSurvey.content?.pages
          .find((s) => s.name === currentSectionName)
          .elements[0].elements.map((item, index) =>
            item.type === "html" ? index : null
          )
          .filter((index) => index !== null);
        surveyContentQIndex = htmlIndexes[pageIndex] + questionIndex + 1;
      }
    } else {
      if (newQuestion.from === "qbank" || newQuestion.from === "inputpanel") {
        sectionQIndex = _sections
          .find((s) => s.name === currentSectionName)
          ?.pages.find((p) => p.name === currentPageName).questions.length;
        const htmlIndexes = _editingSurvey.content?.pages
          .find((s) => s.name === currentSectionName)
          .elements[0].elements.map((item, index) =>
            item.type === "html" ? index : null
          )
          .filter((index) => index !== null);
        const htmlIndex = _editingSurvey.content?.pages
          .find((s) => s.name === currentSectionName)
          .elements[0].elements.findIndex(
            (item) => item.type === "html" && item.name === currentPageName
          );
        if (htmlIndexes.indexOf(htmlIndex) === htmlIndexes.length - 1) {
          surveyContentQIndex = _editingSurvey.content?.pages.find(
            (s) => s.name === currentSectionName
          ).elements[0].elements.length;
        } else {
          surveyContentQIndex = htmlIndexes[htmlIndexes.indexOf(htmlIndex) + 1];
        }
      } else {
        sectionQIndex = questionIndex;
        const htmlIndex = _editingSurvey.content?.pages
          .find((s) => s.name === currentSectionName)
          .elements[0].elements.findIndex(
            (item) => item.type === "html" && item.name === currentPageName
          );
        surveyContentQIndex = htmlIndex + questionIndex + 1;
      }
    }

    return {
      sectionQIndex: sectionQIndex,
      surveyContentQIndex: surveyContentQIndex,
    };
  }

  async function addNewQuestion(pageIndex, questionIndex, newQuestion) {
    let _sections = [...sections];
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    let currentSectionName = selectedSectionAndPage.sectionName;
    let currentPageName = selectedSectionAndPage.pageName;
    let currentSectionIndex = selectedSectionAndPage.sectionIndex;

    if (_sections.length === 0) {
      _sections.push({
        name: "New Section",
        pages: [
          {
            name: "New Page",
            questions: [],
          },
        ],
      });
      _editingSurvey.content.pages.push({
        name: "New Section",
        title: "New Section",
        elements: [
          {
            type: "panel",
            name: "New Section",
            elements: [
              {
                type: "html",
                name: "New Page",
                html: "<h5>New Page</h5>",
              },
            ],
          },
        ],
      });

      // dispatch(setCurrentSurvey(_editingSurvey));
      dispatch(
        updateTabStates(topMenuTabs.activeTab, "currentSurvey", _editingSurvey)
      );

      currentSectionName = "New Section";
      currentPageName = "New Page";
      currentSectionIndex = 0;
    } else if (_sections[currentSectionIndex].pages.length === 0) {
      _sections[currentSectionIndex].pages.push({
        name: "New Page",
        questions: [],
      });
      _editingSurvey.content.pages
        .find((s) => s.name === currentSectionName)
        .elements[0].elements.push({
          type: "html",
          name: "New Page",
          html: "<h5>New Page</h5>",
        });

      // dispatch(setCurrentSurvey(_editingSurvey));
      dispatch(
        updateTabStates(topMenuTabs.activeTab, "currentSurvey", _editingSurvey)
      );

      currentPageName = "New Page";
    } else if (questionIsExist(newQuestion.question)) {
      setQuestionAddInfoMenuShow(true);
      return;
    }

    const newQIndexes = getNewQIndexes(
      currentSectionName,
      currentPageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );
    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    let _sectionNewQuestion = {};
    let _editingSurveyNewQuestion = {};
    if (newQuestion.type === "radiogroup" || newQuestion.type === "dropdown") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        weight: 1.0,
        editing_weight: 1.0,
        elements: newQuestion.from === "qbank" ? newQuestion.options : [],
        editing_elements:
          newQuestion.from === "qbank" ? newQuestion.options : [],
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: newQuestion.type,
        weight: 1.0,
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        choices: newQuestion.from === "qbank" ? newQuestion.options : [],
      };
    } else if (newQuestion.type === "tagbox") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        elements: newQuestion.from === "qbank" ? newQuestion.options : [],
        editing_elements:
          newQuestion.from === "qbank" ? newQuestion.options : [],
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: newQuestion.type,
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        choices: newQuestion.from === "qbank" ? newQuestion.options : [],
      };
    } else if (newQuestion.type === "checkbox") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        elements: newQuestion.from === "qbank" ? newQuestion.options : [],
        editing_elements:
          newQuestion.from === "qbank" ? newQuestion.options : [],
        colCount: 1,
        showNoneItem: true,
        editing_showNoneItem: true,
        showOtherItem: true,
        editing_showOtherItem: true,
        showSelectAllItem: true,
        editing_showSelectAllItem: true,
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "checkbox",
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        choices: newQuestion.from === "qbank" ? newQuestion.options : [],
        showNoneItem: true,
        showOtherItem: true,
        showSelectAllItem: true,
      };
    } else if (newQuestion.type === "rating") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        weight: 1.0,
        editing_weight: 1.0,
        rateCount: 5,
        editing_rateCount: 5,
        rateMax: 5,
        rateType: "stars",
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "rating",
        weight: 1.0,
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        rateCount: 5,
        rateMax: 5,
        rateType: "stars",
        displayMode: "buttons",
      };
    } else if (newQuestion.type === "boolean") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        renderAs: "switch",
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "boolean",
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        valueTrue: "Yes",
        valueFalse: "No",
      };
    } else if (newQuestion.type === "comment") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        rows: 3,
        allowResize: true,
        maxLength: 0,
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "comment",
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        rows: 2,
        autoGrow: true,
        allowResize: true,
      };
    } else if (newQuestion.type === "text") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        inputType: "text",
        editing_inputType: "text",
        maxLength: 100,
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "text",
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        min: 0,
        max: 100,
        inputType: "text",
      };
    } else if (newQuestion.type === "ranking") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        elements: newQuestion.from === "qbank" ? newQuestion.options : [],
        editing_elements:
          newQuestion.from === "qbank" ? newQuestion.options : [],
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "ranking",
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        choices: newQuestion.from === "qbank" ? newQuestion.options : [],
      };
    }

    if (currentPageName === "All") {
      if (newQuestion.from === "qbank" || newQuestion.from === "inputpanel") {
        _sections[currentSectionIndex].pages[
          _sections[currentSectionIndex].pages.length - 1
        ].questions.push(_sectionNewQuestion);
      } else {
        _sections[currentSectionIndex].pages[pageIndex].questions.splice(
          sectionQIndex,
          0,
          _sectionNewQuestion
        );
      }
    } else {
      if (newQuestion.from === "qbank" || newQuestion.from === "inputpanel") {
        _sections[currentSectionIndex].pages
          .find((p) => p.name === currentPageName)
          .questions.push(_sectionNewQuestion);
      } else {
        _sections[currentSectionIndex].pages
          .find((p) => p.name === currentPageName)
          .questions.splice(sectionQIndex, 0, _sectionNewQuestion);
      }
    }

    _editingSurvey.content.pages
      .find((s) => s.name === currentSectionName)
      .elements[0].elements.splice(surveyContentQIndex, 0, {
        type: "panel",
        name: "",
        elements: [_editingSurveyNewQuestion],
      });

    setSections(_sections);
    setEditingSurvey(_editingSurvey);
    if (newQuestion.from === "qbank" || newQuestion.from === "inputpanel") {
      scrollToBottom();
    }
    if (newQuestion.from === "qbank") {
      saveChanges(_editingSurvey);
    }
  }

  async function getQuestions() {
    await getQuestionsFromAPI(token)
      .then((questions) => {
        dispatch(setQuestions(questions));
      })
      .catch((error) => {});
  }

  async function saveChanges(_editingSurvey) {
    for (const page of _editingSurvey.content.pages) {
      for (const element of page.elements[0].elements || []) {
        if (element.type === "panel") {
          if (element.elements[0].title?.length > 0) {
            if (
              questions.find(
                (q) =>
                  q.question.trim() === element.elements[0].title.trim() &&
                  q.type === element.elements[0].type &&
                  (q.options.sort().join() || "") ===
                    (element.elements[0].choices
                      ?.map((x) => x.text)
                      .sort()
                      .join() || "")
              )
            ) {
              element.elements[0]["name"] = questions.find(
                (q) =>
                  q.question.trim() === element.elements[0].title.trim() &&
                  q.type === element.elements[0].type &&
                  (q.options.sort().join() || "") ===
                    (element.elements[0].choices
                      ?.map((x) => x.text)
                      .sort()
                      .join() || "")
              ).ID;
            } else {
              const obj = {
                options: element.elements[0].choices?.map((x) => x.text) || [],
                question: element.elements[0].title.trim(),
                type: element.elements[0].type,
                organization_id: organizations.find(
                  (x) => x.organization_name === currentSurvey.organization
                ).ID,
              };
              console.log("soru ekleniyor...", obj);
              await addQuestionFromAPI(token, obj)
                .then((res) => {
                  element.elements[0]["name"] = res["question_id"];
                  getQuestions();
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }
        }
      }
    }

    setEditingSurvey(_editingSurvey);

    const obj = {
      content: _editingSurvey.content,
    };
    await updateSurveyFromAPI(token, obj, _editingSurvey.ID)
      .then((result) => {
        // dispatch(setCurrentSurvey(_editingSurvey));
        dispatch(
          updateTabStates(
            topMenuTabs.activeTab,
            "currentSurvey",
            _editingSurvey
          )
        );
      })
      .catch((error) => {
        console.log("update survey error : ", error);
      });
  }

  const handleClickOutside = (event) => {
    // Eğer tıklama menü dışında gerçekleştiyse, menüyü kapat
    if (
      questionTypesMenuRef.current &&
      !questionTypesMenuRef.current.contains(event.target)
    ) {
      setShowQuestionTypes(false);
    }
    if (
      textQuestionTypesMenuRef.current &&
      !textQuestionTypesMenuRef.current.contains(event.target)
    ) {
      setShowTextQuestionTypes(false);
    }
  };
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDeleteInfoMenuShow(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [deleteInfoMenuShow, setDeleteInfoMenuShow]);

  const updateSectionType = (checked) => {
    let _editingSurvey = JSON.parse(JSON.stringify(editingSurvey));
    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName?.toLowerCase()
    ).type = checked ? "demographics" : "";
    _editingSurvey.content.pages.forEach((page) => {
      if (
        page.name.toLowerCase() !==
        selectedSectionAndPage.sectionName?.toLowerCase()
      ) {
        page.type = "";
      }
    });
    setEditingSurvey(_editingSurvey);

    saveChanges(_editingSurvey);
  };

  return (
    <div className={`flex w-full`}>
      <div
        className={`flex flex-grow  flex flex-col items-center justify-center p-6   
                    ${themeMode === "dark" ? "bg-[#1a1a28]" : "bg-[#ffffff]"}
                    ${
                      currentSurvey.status !== "Draft"
                        ? "cursor:auto pointer-events-none opacity-50"
                        : ""
                    }
                `}
      >
        <div className={`flex flex-row items-end justify-between w-full pb-6`}>
          <div
            className={`flex items-center text-lg font-semibold ${
              themeMode === "dark" ? "text-white" : "text-black"
            }`}
          >
            {selectedSectionAndPage.sectionName
              ? "Section: " + selectedSectionAndPage.sectionName
              : ""}
          </div>
          <div>
            {/* Açma Butonu */}
            <button
              onClick={() => setIsPreviewOpen(true)}
              className=" bottom-5 right-5 p-2 bg-blue-600 text-white rounded-full shadow-lg"
            >
              <EyeIcon className="w-4 h-4"  />
            </button>

            {/* Modal */}
            {isPreviewOpen && (
              <div className="fixed inset-0  z-[99999] bg-black bg-opacity-50 flex justify-center items-center">
                <div className="bg-white p-6 relative  w-screen h-screen overflow-y-auto">
                  {/* Kapatma Butonu */}
                  <button
                    onClick={() => setIsPreviewOpen(false)}
                    className="absolute top-[0] right-3 text-gray-600 hover:text-black mb-4"
                  >
                    <XMarkIcon className="w-6 h-6" />
                  </button>

                  {/* İçerik */}
                  <SurveyPreview surveyData={currentSurvey.content} />
                </div>
              </div>
            )}
          </div>
        </div>
        {/* {currentSurvey?.content?.pages.length > 0 && (
                    <div className="flex justify-start w-full">
                        <div className="flex justify-start space-x-2">
                            <input
                                type="checkbox"
                                id="demographics"
                                name="demographics"
                                checked={currentSurvey?.content?.pages.find(s => s.name.toLowerCase() === selectedSectionAndPage.sectionName?.toLowerCase())?.type === "demographics"}
                                onChange={(e) => updateSectionType(e.target.checked)}
                                className="h-4 w-4 text-blue-800 border border-gray-300 rounded cursor-pointer"
                            />
                            <label
                                htmlFor="demographics"
                                className="text-sm font-small text-gray-400 cursor-pointer"
                            >
                                Mark as Demographics
                            </label>
                            <div className="relative group">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4 text-gray-400 cursor-pointer"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <circle cx="12" cy="12" r="10" />
                                    <line x1="12" y1="16" x2="12" y2="12" />
                                    <line x1="12" y1="8" x2="12.01" y2="8" />
                                </svg>
                                <div className="absolute bottom-full left-full mt-2 w-60 bg-gray-800 text-white text-xs rounded-lg p-2 hidden group-hover:block">
                                    Questions in the demographic section will not be included in the scoring.
                                </div>
                            </div>
                        </div>
                    </div>
                )} */}
        <DragDropContext
          onDragEnd={(e) => onDragEnd(e)}
          key={"section-key"}
          className="cursor:auto pointer-events-none opacity-50"
        >
          {selectedSectionAndPage.sectionName &&
            sections
              .find(
                (s) =>
                  s.name.toLowerCase() ===
                  selectedSectionAndPage.sectionName.toLowerCase()
              )
              ?.pages.filter(
                (p) =>
                  p.name === selectedSectionAndPage.pageName ||
                  selectedSectionAndPage.pageName === "All"
              )
              .map((page, pageIndex) => (
                <Droppable
                  droppableId={"droppable-" + pageIndex}
                  key={"droppable-" + pageIndex}
                >
                  {(provided, snapshot) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className={`droppable-area relative ${
                        snapshot.isDraggingOver ? "dragging-over" : ""
                      }  flex flex-col text-white items-center justify-center w-full  ${
                        themeMode === "dark"
                          ? "bg-[#a5bdff0d]"
                          : "bg-[#1530720d]"
                      } rounded-lg p-8 mb-6 space-y-8 pb-10 min-h-[150px]`}
                    >
                      {!(
                        selectedSectionAndPage.sectionName === page.name &&
                        sections
                          .find(
                            (s) =>
                              s.name.toLowerCase() ===
                              selectedSectionAndPage.sectionName.toLowerCase()
                          )
                          ?.pages.filter(
                            (p) =>
                              p.name === selectedSectionAndPage.pageName ||
                              selectedSectionAndPage.pageName === "All"
                          ).length === 1
                      ) && (
                        <div
                          className={`absolute top-0 left-50 bg-[#a5bdff1a] px-2 py-1 rounded-b-lg ${
                            themeMode === "dark" ? "text-white" : "text-black"
                          }`}
                        >
                          Page: {page.name}
                        </div>
                      )}
                      {page.questions.map((question, qIndex) => (
                        <div
                          key={`question-${qIndex}`}
                          className=" relative flex flex-col w-full space-y-3 p-4 pt-4"
                        >
                          <Draggable
                            key={`question-${qIndex}`}
                            draggableId={`question-${pageIndex}-${qIndex}`}
                            index={qIndex}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className=" relative group flex flex-col w-full space-y-3 p-4 border border-dashed border-gray-400 rounded-lg hover:border-gray-600 hover:shadow-lg hover:bg-[#a5bdff0d]"
                              >
                                <div
                                  className={`absolute bottom-0 right-0 px-2 py-1 rounded-tl-lg cursor-pointer flex items-center space-x-2 ${
                                    themeMode === "dark"
                                      ? " text-white"
                                      : "  text-black-8"
                                  }`}
                                >
                                  {!question?.isEditing &&
                                    (question.type === "radiogroup" ||
                                      question.type === "dropdown" ||
                                      question.type === "rating") &&
                                    currentSurvey?.content?.pages.find(
                                      (s) =>
                                        s.name.toLowerCase() ===
                                        selectedSectionAndPage.sectionName?.toLowerCase()
                                    )?.type !== "demographics" && (
                                      <span className="text-sm font-medium hidden sm:block">
                                        Weight: {question?.weight}
                                      </span>
                                    )}
                                  {!question?.isEditing && (
                                    <div className="flex items-center space-x-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                      </svg>
                                      <span className="text-sm font-medium hidden sm:block">
                                        {fixQuestionTypeName(
                                          question?.editing_type
                                        )}
                                      </span>
                                    </div>
                                  )}

                                  {question?.isEditing &&
                                    (question.editing_type === "radiogroup" ||
                                      question.editing_type === "dropdown" ||
                                      question.editing_type === "rating") &&
                                    currentSurvey?.content?.pages.find(
                                      (s) =>
                                        s.name.toLowerCase() ===
                                        selectedSectionAndPage.sectionName?.toLowerCase()
                                    )?.type !== "demographics" && (
                                      <div className="flex items-center space-x-2">
                                        <span className="text-sm font-medium hidden sm:block">
                                          Weight:
                                        </span>
                                        <input
                                          id="numberInput"
                                          type="text"
                                          value={question?.editing_weight.toString()}
                                          onChange={(e) =>
                                            handleWeightChange(
                                              pageIndex,
                                              qIndex,
                                              e.target.value
                                            )
                                          }
                                          className={`text-sm font-medium bg-transparent border rounded-md p-1 w-12 text-center ${
                                            themeMode === "dark"
                                              ? " text-white border-1 border-gray-400"
                                              : "  text-black border border-black-06"
                                          }`}
                                        />
                                      </div>
                                    )}
                                  {question?.isEditing && (
                                    <div className=" relative font-normal text-[1.25rem] cursor-pointer w-full min-w-0 min-h-0 flex items-center flex-nowrap">
                                      {question?.editing_type && (
                                        <button
                                          className={` text-[0.875rem] p-1 border hover: rounded-md ${
                                            themeMode === "dark"
                                              ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                              : "bg-[#ffffff0a] text-black border-black-06"
                                          }`}
                                          onClick={() => {
                                            if (
                                              activeQuestionIndex === qIndex
                                            ) {
                                              setShowQuestionTypes(false); // Menü açma/kapama
                                              setActiveQuestionIndex(null);
                                            } else {
                                              setActiveQuestionIndex(qIndex); // Yeni soruyu aktif yap
                                              setShowQuestionTypes(true); // Menüyü aç
                                            }
                                          }}
                                        >
                                          <div className="flex items-center justify-start">
                                            {/* <span>{questionTypes.find(x => x.name === fixQuestionTypeName(question?.type)).img}</span> */}
                                            <span>
                                              {fixQuestionTypeName(
                                                question?.editing_type
                                              )}
                                            </span>
                                          </div>
                                        </button>
                                      )}
                                      {showQuestionTypes &&
                                        activeQuestionIndex === qIndex && (
                                          <div
                                            ref={questionTypesMenuRef}
                                            id="questionTypesMenu"
                                            className={`absolute flex flex-col  ${
                                              qIndex ===
                                              page.questions.length - 1
                                                ? "bottom-10"
                                                : "top-9"
                                            } left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${
                                              themeMode === "dark"
                                                ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                : " bg-gray-200 text-black border-black-06"
                                            }`}
                                          >
                                            {questionTypes.map(
                                              (questionType) => (
                                                <div
                                                  key={questionType.value}
                                                  className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                  onClick={() =>
                                                    updateQuestionType(
                                                      pageIndex,
                                                      qIndex,
                                                      fixQuestionTypeName(
                                                        questionType?.name
                                                      )
                                                    )
                                                  }
                                                >
                                                  <div className="flex items-center justify-start text-xs my-1">
                                                    <span
                                                      className={`${
                                                        themeMode === "dark"
                                                          ? "text-white text-opacity-60"
                                                          : "text-[#000] text-opacity-60"
                                                      }`}
                                                    >
                                                      {questionType.img}
                                                    </span>
                                                    <span
                                                      className={`ml-1 ${
                                                        themeMode === "dark"
                                                          ? "text-white text-opacity-60"
                                                          : "text-[#000] text-opacity-60"
                                                      } `}
                                                    >
                                                      {questionType?.name}
                                                    </span>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        )}
                                    </div>
                                  )}

                                  {/* Eklenen text */}
                                  <button
                                    className={`flex justify-end sm:justify-center items-center flex-nowrap flex-shrink-0   cursor-pointer group inline-flex items-center   py-1 pl-2 pr-2 text-sm font-medium sm:min-w-[4.5rem] sm:max-w-[4.9rem]"`}
                                    onClick={() =>
                                      updateQuestionIsRequired(
                                        question,
                                        pageIndex,
                                        qIndex
                                      )
                                    }
                                  >
                                    {question?.isRequired ? (
                                      <>
                                        <RequiredIcon
                                          className="w-4 h-4  mr-1"
                                          fill={`${
                                            themeMode === "dark"
                                              ? " white"
                                              : "  black"
                                          }`}
                                        />
                                        <span className="hidden sm:block">
                                          Required
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <NotRequiredIcon
                                          className="w-4 h-4"
                                          fill={`${
                                            themeMode === "dark"
                                              ? "white"
                                              : "black"
                                          }`} // Ana fill rengi
                                          circleFill={`${
                                            themeMode === "dark"
                                              ? "none"
                                              : "white"
                                          }`} // Circle için özel renk
                                          circleStroke={`${
                                            themeMode === "dark"
                                              ? "white"
                                              : "black"
                                          }`} // Circle için stroke rengi
                                        />
                                        <span className="hidden sm:block">
                                          Not Required
                                        </span>
                                      </>
                                    )}
                                  </button>
                                </div>
                                <div className="absolute top-0 right-0 px-2 py-0 rounded-tl-lg flex items-center justify-center space-x-2 hidden group-hover:flex">
                                  {question?.isEditing && (
                                    <button
                                      title="Cancel"
                                      className={`flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${
                                        themeMode === "dark"
                                          ? "text-[#FFFFFF]"
                                          : "text-black"
                                      }  cursor-pointer group inline-flex items-center  py-1 pl-1 pr-1 text-sm font-medium min-w-[1.5rem] max-w-[4.9rem]"`}
                                      onClick={() =>
                                        undoQuestionChanges(
                                          question,
                                          pageIndex,
                                          qIndex
                                        )
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M6 18 18 6M6 6l12 12"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                  {question?.isEditing && (
                                    <button
                                      title="Save"
                                      className={`flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${
                                        themeMode === "dark"
                                          ? "text-[#FFFFFF]"
                                          : "text-black"
                                      } 
                                                                        ${
                                                                          question?.is_exist
                                                                            ? "text-gray-400 cursor-not-allowed"
                                                                            : ""
                                                                        } cursor-pointer group inline-flex items-center  py-1 pl-1 pr-1 text-sm font-medium min-w-[1.5rem] max-w-[4.9rem]"`}
                                      disabled={question?.is_exist}
                                      onClick={() =>
                                        saveQuestionChanges(
                                          question,
                                          pageIndex,
                                          qIndex
                                        )
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="m4.5 12.75 6 6 9-13.5"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                  {!question?.isEditing && (
                                    <button
                                      title="Edit Question"
                                      className={`flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${
                                        themeMode === "dark"
                                          ? "text-[#FFFFFF]"
                                          : "text-black"
                                      }  cursor-pointer group inline-flex items-center  py-1 pl-1 pr-1 text-sm font-medium min-w-[1.5rem] max-w-[4.9rem]"`}
                                      onClick={() =>
                                        updateQuestionIsEditing(
                                          question,
                                          pageIndex,
                                          qIndex
                                        )
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-4"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                  <button
                                    title="Delete Question"
                                    onClick={() => {
                                      setSelectedParam({
                                        param: "question",
                                        pageIndex: pageIndex,
                                        qIndex: qIndex,
                                        index: null,
                                        questionType: null,
                                      });
                                      setDeleteAllowMenuOpen(true);
                                    }}
                                    className={`flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${
                                      themeMode === "dark"
                                        ? "text-[#FFFFFF]"
                                        : "text-black"
                                    } cursor-pointer group inline-flex items-center  py-1 pl-1 pr-1 text-sm font-medium min-w-[1.5rem] max-w-[4.9rem]"`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth="1.5"
                                      stroke="currentColor"
                                      className="size-4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                      />
                                    </svg>
                                  </button>
                                </div>

                                {!question?.isEditing && (
                                  <div className="pb-4 ">
                                    <p
                                      className={`font-semibold text-lg mt-0  break-words ${
                                        themeMode === "dark"
                                          ? "placeholder:text-white text-white "
                                          : " text-[#0f121a] placeholder:text-[#0f121a]"
                                      } max-w-full`}
                                    >
                                      {question?.name}
                                    </p>
                                    <div className="flex flex-col space-y-2 mt-2">
                                      {question?.editing_type === "rating" && (
                                        <div className="rating-container flex space-x-1">
                                          {/* theme değerine göre renk belirleme */}
                                          {Array.from({
                                            length: question?.editing_rateCount,
                                          }).map((_, index) => {
                                            const fillColor =
                                              themeMode === "dark"
                                                ? "white"
                                                : "#14141f"; // Tema kontrolü

                                            return (
                                              <svg
                                                key={index}
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill={fillColor} // Dinamik renk
                                                className="size-6"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            );
                                          })}
                                        </div>
                                      )}
                                      {question?.editing_type === "boolean" &&
                                        null}
                                      {(question?.editing_type ===
                                        "radiogroup" ||
                                        question?.editing_type === "dropdown" ||
                                        question?.editing_type === "tagbox" ||
                                        question?.editing_type === "checkbox" ||
                                        question?.editing_type === "ranking") &&
                                        question?.editing_elements.map(
                                          (element, index) =>
                                            question?.editing_type ===
                                            "checkbox" ? (
                                              <div
                                                key={index}
                                                className={`flex items-center space-x-2 ${
                                                  themeMode === "dark"
                                                    ? "placeholder:text-white text-white "
                                                    : " text-[#0f121a] placeholder:text-[#0f121a]"
                                                }`}
                                              >
                                                <input
                                                  type="radio"
                                                  id={element.value}
                                                  name={element.value}
                                                  value={element.value}
                                                  disabled
                                                />
                                                <label htmlFor={element.text}>
                                                  {element.text}
                                                </label>
                                              </div>
                                            ) : (
                                              <div
                                                key={index}
                                                className={`flex items-center space-x-2 ${
                                                  themeMode === "dark"
                                                    ? "placeholder:text-white text-white "
                                                    : " text-[#0f121a] placeholder:text-[#0f121a]"
                                                }`}
                                              >
                                                <input
                                                  type="radio"
                                                  id={element.value}
                                                  name={element.value}
                                                  value={element.value}
                                                  disabled
                                                />
                                                <label htmlFor={element.value}>
                                                  {element.text}
                                                </label>
                                              </div>
                                            )
                                        )}
                                      {question?.editing_type === "comment" && (
                                        <div className="w-full mt-0 mb-0"></div>
                                      )}
                                      {question?.editing_type === "text" && (
                                        <div className="w-full mt-4 mb-4">
                                          <div
                                            className={`flex items-center space-x-2 ${
                                              themeMode === "dark"
                                                ? "placeholder:text-white text-white "
                                                : " text-[#0f121a] placeholder:text-[#0f121a]"
                                            }`}
                                          >
                                            <label htmlFor={question?.name}>
                                              {question?.name}
                                            </label>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                                {question?.isEditing && (
                                  <div className="mt-4 sm:mt-0">
                                    {/* Question adı input */}

                                    <Combobox
                                      as="div"
                                      value={question?.editing_name}
                                    >
                                      {/* <div className="relative w-72"> */}
                                      <ComboboxInput
                                        className={`w-full p-2 border border-gray-400 rounded-lg mt-4 ${
                                          themeMode === "dark"
                                            ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                            : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                        }`}
                                        onChange={(e) =>
                                          handleQuestionNameChange(
                                            pageIndex,
                                            qIndex,
                                            e.target.value
                                          )
                                        } // Question adı değiştirildiğinde tetiklenecek
                                        // onBlur={() => setQuery("")} // Arama kaybolduğunda temizle
                                        displayValue={(name) => name} // Seçilen öğe etiketini göster
                                        placeholder="New Question"
                                      />
                                      {/* warning info */}
                                      {question?.is_exist &&
                                        question?.editing_name.length > 0 && (
                                          <p className="text-red-500 text-xs mt-1">
                                            Question is already exist*
                                          </p>
                                        )}
                                      {filteredQuestions.length > 0 && (
                                        <ComboboxOptions
                                          className={`absolute z-50 mt-1 max-h-40 w-full overflow-auto rounded-md py-1 text-base sm:text-sm border border-[1px] border-solid ${
                                            themeMode === "dark"
                                              ? "bg-[#2a2939] border-white-09 shadow-theme-popup-shadow"
                                              : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                                          }`}
                                        >
                                          {filteredQuestions.map((option) => (
                                            <ComboboxOption
                                              key={option.ID}
                                              value={option.question} // Burada tam option nesnesini geçiriyoruz
                                              className={`relative group  flex flex-row justify-between cursor-pointer py-2 pl-8 pr-4 ${
                                                themeMode === "dark"
                                                  ? "hover:bg-[#333240] text-white"
                                                  : "hover:bg-[#EBEBEB] text-black"
                                              }`}
                                              onClick={(e) => {
                                                editQuestionFromQBank(
                                                  pageIndex,
                                                  qIndex,
                                                  option
                                                );
                                              }}
                                            >
                                              <span className="block truncate group-data-[selected]:font-semibold">
                                                {option.question}
                                              </span>
                                              <span className="ml-2 block group-data-[selected]:font-semibold">
                                                {option.type}
                                              </span>
                                            </ComboboxOption>
                                          ))}
                                        </ComboboxOptions>
                                      )}
                                      {/* </div> */}
                                    </Combobox>

                                    {/* Seçeneklerin listesi */}
                                    {question?.editing_type === "rating" && (
                                      <div className="rating-component mt-8">
                                        {/* Minus ve Plus Butonları */}
                                        <div className="flex items-center space-x-4">
                                          {/* Minus Button */}
                                          <button
                                            onClick={() => {
                                              decreaseRate(pageIndex, qIndex);
                                            }}
                                            className={`plus-btn px-3 py-1  ${
                                              themeMode === "dark"
                                                ? "text-[#FFFFFF]"
                                                : "text-black"
                                            } rounded`}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              strokeWidth="1.5"
                                              stroke="currentColor"
                                              className="size-6"
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                              />
                                            </svg>
                                          </button>

                                          {/* Rating SVG Container */}
                                          <div className="rating-container flex space-x-1">
                                            {Array.from({
                                              length:
                                                question?.editing_rateCount,
                                            }).map((_, index) => {
                                              const fillColor =
                                                themeMode === "dark"
                                                  ? "white"
                                                  : "#14141f";
                                              return (
                                                <svg
                                                  key={index}
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 24 24"
                                                  fill={fillColor}
                                                  className="size-6"
                                                >
                                                  <path
                                                    fillRule="evenodd"
                                                    d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                    clipRule="evenodd"
                                                  />
                                                </svg>
                                              );
                                            })}
                                          </div>

                                          {/* Plus Button */}
                                          <button
                                            onClick={() => {
                                              increaseRate(pageIndex, qIndex);
                                            }}
                                            className={`plus-btn px-3 py-1  ${
                                              themeMode === "dark"
                                                ? "text-[#FFFFFF]"
                                                : "text-black"
                                            } rounded`}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              strokeWidth="1.5"
                                              stroke="currentColor"
                                              className="size-6"
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                              />
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                    {question?.editing_type === "boolean" && (
                                      <div className="flex justify-center space-x-4 mt-6"></div>
                                    )}
                                    {(question.editing_type === "radiogroup" ||
                                      question.editing_type === "dropdown" ||
                                      question.editing_type === "tagbox" ||
                                      question.editing_type === "checkbox" ||
                                      question.editing_type === "ranking") && (
                                      <div className="flex flex-col">
                                        <div className="flex flex-col space-y-2 mt-2">
                                          {question.editing_elements.map(
                                            (element, index) =>
                                              question.editing_type ===
                                              "checkbox" ? (
                                                <div className="flex space-x-2">
                                                  <div
                                                    key={index}
                                                    className={`w-full m-0 p-0 min-w-0 relative border-none rounded-[2px] font-inherit bg-transparent outline-none 
                                                         space-x-2 flex justify-start ${
                                                      themeMode === "dark"
                                                        ? "text-white text-opacity-60"
                                                        : "text-[#000] text-opacity-60"
                                                    }`}
                                                  >
                                                    {/* Radio buton */}
                                                    <input
                                                      type="radio"
                                                      id={element.value}
                                                      name={element.value}
                                                      value={element.value}
                                                      disabled
                                                    />

                                                    {/* Option metni input */}
                                                    <input
                                                      value={element.text}
                                                      placeholder="Option Text"
                                                      className={`w-full p-2 border border-gray-400 rounded-lg  ${
                                                        themeMode === "dark"
                                                          ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                          : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                      }`}
                                                      onChange={(e) =>
                                                        handleChoiceTextChange(
                                                          pageIndex,
                                                          qIndex,
                                                          index,
                                                          e.target.value,
                                                          question.editing_type
                                                        )
                                                      }
                                                    />
                                                    <div
                                                      title="Delete Option"
                                                      className={`icon no-gap  inline-flex justify-center  items-center  absolute top-1/2 right-2 transform -translate-y-1/2 cursor-pointer ${
                                                        themeMode === "dark"
                                                          ? "text-[#ffffff]"
                                                          : "text-[#000]"
                                                      }`}
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth="1.5"
                                                        stroke="currentColor"
                                                        className="size-4 "
                                                        onClick={() => {
                                                          setSelectedParam({
                                                            param: "option",
                                                            pageIndex:
                                                              pageIndex,
                                                            qIndex: qIndex,
                                                            index: index,
                                                            questionType:
                                                              question.editing_type,
                                                          });
                                                          setInfoText(
                                                            "Are you sure you want to delete this option"
                                                          );
                                                          setDeleteAllowMenuOpen(
                                                            true
                                                          );
                                                        }} // İkona tıklanıldığında soru silinir
                                                      >
                                                        <path
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                        />
                                                      </svg>
                                                    </div>
                                                    {/* Option value input */}
                                                  </div>
                                                </div>
                                              ) : (
                                                <div
                                                  key={index}
                                                  className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] font-inherit bg-transparent outline-none  space-x-2 flex justify-start ${
                                                    themeMode === "dark"
                                                      ? "text-white text-opacity-60"
                                                      : "text-[#000] text-opacity-60"
                                                  }`}
                                                >
                                                  {/* Radio buton */}
                                                  <input
                                                    type="radio"
                                                    id={element.value}
                                                    name={element.value}
                                                    value={element.value}
                                                    disabled
                                                  />

                                                  {/* Option metni input */}
                                                  <input
                                                    value={element.text}
                                                    placeholder="Option Text"
                                                    className={`w-full p-2 border border-gray-400 rounded-lg  ${
                                                      themeMode === "dark"
                                                        ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                        : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                    }`}
                                                    onChange={(e) =>
                                                      handleChoiceTextChange(
                                                        pageIndex,
                                                        qIndex,
                                                        index,
                                                        e.target.value,
                                                        question.editing_type
                                                      )
                                                    }
                                                  />
                                                  {(question.editing_type ===
                                                    "radiogroup" ||
                                                    question.editing_type ===
                                                      "dropdown") &&
                                                    currentSurvey?.content?.pages.find(
                                                      (s) =>
                                                        s.name.toLowerCase() ===
                                                        selectedSectionAndPage.sectionName?.toLowerCase()
                                                    )?.type !==
                                                      "demographics" && (
                                                      <input
                                                        id="numberInput"
                                                        type="text"
                                                        value={
                                                          element.weight
                                                            ? element.weight
                                                            : (
                                                                (5 /
                                                                  question
                                                                    .editing_elements
                                                                    .length) *
                                                                (index + 1)
                                                              ).toFixed(1)
                                                        }
                                                        onChange={(e) =>
                                                          handleOptionWeightChange(
                                                            pageIndex,
                                                            qIndex,
                                                            index,
                                                            e.target.value,
                                                            question.editing_type
                                                          )
                                                        }
                                                        className={`pl-3 border border-gray-400 rounded-lg w-11 ${
                                                          themeMode === "dark"
                                                            ? " bg-[#1C1C29] border-gray-600 placeholder:text-white text-white"
                                                            : " border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                        }`}
                                                      />
                                                    )}
                                                  <div
                                                    title="Delete Option"
                                                    className={`icon inline-flex justify-center items-center cursor-pointer ${
                                                      themeMode === "dark"
                                                        ? "text-[#ffffff]"
                                                        : "text-[#000]"
                                                    }`}
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      fill="none"
                                                      viewBox="0 0 24 24"
                                                      strokeWidth="1.5"
                                                      stroke="currentColor"
                                                      className="size-4 "
                                                      onClick={() => {
                                                        setSelectedParam({
                                                          param: "option",
                                                          pageIndex: pageIndex,
                                                          qIndex: qIndex,
                                                          index: index,
                                                          questionType:
                                                            question.editing_type,
                                                        });
                                                        setInfoText(
                                                          "Are you sure you want to delete this option"
                                                        );
                                                        setDeleteAllowMenuOpen(
                                                          true
                                                        );
                                                      }}
                                                    >
                                                      <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                      />
                                                    </svg>
                                                  </div>
                                                  {/* Option value input */}
                                                </div>
                                              )
                                          )}
                                        </div>

                                        <div className="flex items-center p-2 ml-4 rounded-md mb-4 sm:mb-0">
                                          <div className="mr-2 text-[#C1C9D6]">
                                            {/* Add Page Icon */}
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="currentColor"
                                              viewBox="0 0 16 16"
                                              className="w-4 h-4"
                                            >
                                              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                            </svg>
                                          </div>
                                          <input
                                            className={`w-full text-[0.875rem] border-0 bg-transparent focus-visible:outline-none ${
                                              themeMode === "dark"
                                                ? "text-white"
                                                : "text-[#5A667E]"
                                            }`}
                                            type="text"
                                            placeholder="Add an Option"
                                            value={question.newOption} // State'e bağlı value
                                            onChange={(e) =>
                                              handleNewOptionChange(
                                                pageIndex,
                                                qIndex,
                                                e.target.value
                                              )
                                            }
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                handleAddOption(
                                                  pageIndex,
                                                  qIndex,
                                                  question.editing_type
                                                );
                                              }
                                            }}
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {question.editing_type === "checkbox" && (
                                      <div className="flex space-x-2 my-2 w-3/4">
                                        <div
                                          className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] font-inherit bg-transparent relative outline-none  space-x-2 flex justify-start ${
                                            themeMode === "dark"
                                              ? "text-white text-opacity-60"
                                              : "text-[#000] text-opacity-60"
                                          }`}
                                        >
                                          <div
                                            className={` ${
                                              themeMode === "dark"
                                                ? "text-white text-opacity-60"
                                                : "text-[#000] text-opacity-60"
                                            } text-[0.875rem] w-1/2`}
                                          >
                                            Show None Item
                                          </div>
                                          <Switch
                                            checked={
                                              question.editing_showNoneItem
                                            }
                                            onChange={(e) =>
                                              handleCheckBoxOptions(
                                                pageIndex,
                                                qIndex,
                                                e,
                                                "showNoneItem"
                                              )
                                            }
                                            className="group  ml-0 inline-flex h-5 w-10 shrink-0 relative cursor-pointer rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                          >
                                            <span className="sr-only">
                                              Use setting
                                            </span>
                                            <span
                                              aria-hidden="true"
                                              className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                            />
                                          </Switch>
                                        </div>
                                        <div
                                          className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] relative font-inherit bg-transparent outline-none  space-x-2 flex justify-start ${
                                            themeMode === "dark"
                                              ? "text-white text-opacity-60"
                                              : "text-[#000] text-opacity-60"
                                          }`}
                                        >
                                          <div
                                            className={` ${
                                              themeMode === "dark"
                                                ? "text-white text-opacity-60"
                                                : "text-[#000] text-opacity-60"
                                            } text-[0.875rem] w-1/2`}
                                          >
                                            Show Other Item
                                          </div>
                                          <Switch
                                            checked={
                                              question.editing_showOtherItem
                                            }
                                            onChange={(e) =>
                                              handleCheckBoxOptions(
                                                pageIndex,
                                                qIndex,
                                                e,
                                                "showOtherItem"
                                              )
                                            }
                                            className="group  ml-0 inline-flex h-5 w-10 shrink-0 cursor-pointer relative rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                          >
                                            <span className="sr-only">
                                              Use setting
                                            </span>
                                            <span
                                              aria-hidden="true"
                                              className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                            />
                                          </Switch>
                                        </div>
                                        <div
                                          className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] relative font-inherit bg-transparent outline-none  space-x-2 flex justify-start ${
                                            themeMode === "dark"
                                              ? "text-white text-opacity-60"
                                              : "text-[#000] text-opacity-60"
                                          }`}
                                        >
                                          <div
                                            className={` ${
                                              themeMode === "dark"
                                                ? "text-white text-opacity-60"
                                                : "text-[#000] text-opacity-60"
                                            } text-[0.875rem] w-1/2`}
                                          >
                                            Show All Item
                                          </div>
                                          <Switch
                                            checked={
                                              question.editing_showSelectAllItem
                                            }
                                            onChange={(e) =>
                                              handleCheckBoxOptions(
                                                pageIndex,
                                                qIndex,
                                                e,
                                                "showSelectAllItem"
                                              )
                                            }
                                            className="group  ml-0 inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent relative bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                          >
                                            <span className="sr-only">
                                              Use setting
                                            </span>
                                            <span
                                              aria-hidden="true"
                                              className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                            />
                                          </Switch>
                                        </div>
                                      </div>
                                    )}

                                    {question.editing_type === "comment" && (
                                      <div className="space-y-4 mt-6 "></div>
                                    )}
                                    {question?.editing_type === "text" && (
                                      <div className="w-full flex justify-start  space-x-4 mt-4 mb-4">
                                        {/* <div className="relative font-normal text-[1.25rem] cursor-pointer w-full min-w-0 min-h-0 flex items-center flex-nowrap"> */}
                                        {question?.editing_inputType &&
                                          // <button
                                          //     className={` text-[0.875rem] p-1 border hover: rounded-md ${themeMode === "dark"
                                          //         ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                          //         : "bg-[#ffffff0a] text-black border-black-06"
                                          //         }`}
                                          //     onClick={() => {
                                          //         if (activeQuestionIndex === qIndex) {
                                          //             setShowTextQuestionTypes(false); // Menü açma/kapama
                                          //             setActiveQuestionIndex(null);
                                          //         } else {
                                          //             setActiveQuestionIndex(qIndex); // Yeni soruyu aktif yap
                                          //             setShowTextQuestionTypes(true); // Menüyü aç
                                          //         }
                                          //     }}
                                          // >
                                          //     <div className="flex items-center justify-start">
                                          //         {/* <span>{questionTypes.find(x => x.name === fixQuestionTypeName(question?.type)).img}</span> */}
                                          //         <span>
                                          //             {question?.editing_inputType}
                                          //         </span>
                                          //     </div>

                                          // </button>
                                          // radiobutton
                                          textQuestionTypes.map(
                                            (questionType) => (
                                              <div
                                                key={questionType.value}
                                                className={`flex items-center justify-start text-center cursor-pointer text-xs my-1 ${
                                                  themeMode === "dark"
                                                    ? "text-white text-opacity-60"
                                                    : "text-[#000] text-opacity-60"
                                                } `}
                                              >
                                                <input
                                                  type="radio"
                                                  className="cursor-pointer"
                                                  id={questionType.value}
                                                  name={questionType.value}
                                                  value={questionType.value}
                                                  checked={
                                                    question?.editing_inputType ===
                                                    questionType.value
                                                  }
                                                  onChange={() =>
                                                    updateTextQuestionType(
                                                      pageIndex,
                                                      qIndex,
                                                      questionType.value
                                                    )
                                                  }
                                                />
                                                <label
                                                  htmlFor={questionType.value}
                                                  className="ml-1 cursor-pointer"
                                                >
                                                  {questionType.value}
                                                </label>
                                              </div>
                                            )
                                          )}
                                        {/* {showTextQuestionTypes && activeQuestionIndex === qIndex && (
                                                                            <div
                                                                                ref={textQuestionTypesMenuRef}
                                                                                id="questionTypesMenu"
                                                                                className={`absolute flex flex-col  ${qIndex === page.questions.length - 1 ? 'bottom-10' : 'top-9'} left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${themeMode === "dark"
                                                                                    ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                                    : " bg-gray-200 text-black border-black-06"
                                                                                    }`}
                                                                            >
                                                                                {textQuestionTypes.map((questionType) => (
                                                                                    <div
                                                                                        key={questionType.value}
                                                                                        className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                                                        onClick={() => updateTextQuestionType(
                                                                                            pageIndex,
                                                                                            qIndex,
                                                                                            questionType.value
                                                                                        )}
                                                                                    >
                                                                                        <div className="flex items-center justify-start text-xs my-1">
                                                                                            <span className={`${themeMode === "dark"
                                                                                                ? "text-white text-opacity-60"
                                                                                                : "text-[#000] text-opacity-60"
                                                                                                } `}>
                                                                                                {questionType.value}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )} */}
                                        {/* </div> */}
                                        {question?.editing_inputType ===
                                          "number" && (
                                          <div className="flex gap-2 ">
                                            <input
                                              type="number"
                                              className={`  rounded-lg  w-full border rounded-md py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 ${
                                                themeMode === "dark"
                                                  ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                  : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                              }`}
                                              value={question?.min}
                                              onChange={(e) => {
                                                changeTextTypeOptions(
                                                  pageIndex,
                                                  qIndex,
                                                  parseInt(e.target.value, 10),
                                                  "min"
                                                );
                                              }}
                                              placeholder="Enter min length"
                                            />
                                            <input
                                              type="number"
                                              className={`w-full p-2  rounded-lg  ${
                                                themeMode === "dark"
                                                  ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                  : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                              }`}
                                              value={question?.max}
                                              onChange={(e) => {
                                                changeTextTypeOptions(
                                                  pageIndex,
                                                  qIndex,
                                                  parseInt(e.target.value, 10),
                                                  "max"
                                                );
                                              }}
                                              placeholder="Enter max length"
                                            />{" "}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </Draggable>
                          <div className="absolute -bottom-6 w-full h-6 pt-0 bg-transparent group">
                            <button
                              className={`absolute left-1/2 transform -translate-x-1/2 ${
                                themeMode === "dark"
                                  ? "text-white hover:bg-[#a5bdff0d]"
                                  : " text-black"
                              }  py-1 h-8 px-3 border border-dashed border-gray-400 rounded-lg hover:border-gray-600 hover:shadow-lg `}
                              onClick={() =>
                                addNewQuestion(pageIndex, qIndex + 1, {
                                  type: "radiogroup",
                                  from: "inside",
                                })
                              }
                            >
                              Add Question
                            </button>
                          </div>
                        </div>
                      ))}
                      {page.questions.length === 0 && (
                        <div className="absolute bottom-6 w-full h-6 pt-0 bg-transparent group">
                          <button
                            className={`absolute left-1/2 transform -translate-x-1/2 ${
                              themeMode === "dark"
                                ? "text-white hover:bg-[#a5bdff0d]"
                                : " text-black"
                            }  py-1 h-8 px-3 border border-dashed border-gray-400 rounded-lg hover:border-gray-600 hover:shadow-lg `}
                            onClick={() =>
                              addNewQuestion(pageIndex, 0, {
                                type: "radiogroup",
                                from: "inside",
                              })
                            }
                          >
                            Add Question
                          </button>
                        </div>
                      )}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              ))}
        </DragDropContext>
        {/* </div> */}
        <div className="fixed bottom-0" ref={scrollRef}></div>
      </div>
      <Dialog
        open={deleteAllowMenuOpen}
        onClose={setDeleteAllowMenuOpen}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${
                themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
              } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold ${
                      themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                    }`}
                  >
                    Delete selected <span>{selectedParam.param}</span>
                  </DialogTitle>
                  <div className="mt-1">
                    <p
                      className={`text-sm ${
                        themeMode === "dark" ? "text-white-8" : "text-black-8"
                      }`}
                    >
                      {infoText}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => {
                    selectedParam.param === "question"
                      ? handleDeleteQuestion(
                          selectedParam.pageIndex,
                          selectedParam.qIndex
                        )
                      : handleDeleteOption(
                          selectedParam.pageIndex,
                          selectedParam.qIndex,
                          selectedParam.index,
                          selectedParam.questionType
                        );
                  }}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${
                    themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                  } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Yes
                </button>
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setDeleteAllowMenuOpen(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid ${
                    themeMode === "dark"
                      ? "bg-white-02 border-white-09 text-white-8 hover:text-white hover:bg-white-04"
                      : "bg-black-02 border-black-09 text-black-8 hover:text-black hover:bg-black-04"
                  } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-1 sm:mt-0`}
                >
                  No
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={deleteInfoMenuShow}
        onClose={setDeleteInfoMenuShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
          <div className="flex min-h-full items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${
                themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
              } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${
                      themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        fill="#008000"
                        stroke="#fff"
                      />
                    </svg>
                    Selected {selectedParam.param} deleted
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setDeleteInfoMenuShow(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${
                    themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                  } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={questionAddInfoMenuShow}
        onClose={setQuestionAddInfoMenuShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
          <div className="flex min-h-full items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${
                themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
              } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${
                      themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      className="size-8 text-red-600"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                    Question is already exist!
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setQuestionAddInfoMenuShow(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${
                    themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                  } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
